module.exports = __webpack_public_path__ + "fonts/AvenirNext-Heavy.ab23ab7b.woff";